module.exports = __webpack_public_path__ + "1734cccecab7b079812206f4977f6194.svg";